import styled from 'styled-components';

export const Container = styled.div`
  .timeline-content {
      max-width: 100%;
  }
`;